<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<ul>
			<li class="flex" v-for="(item, index) in data" :key="index">
				<div class="flex flex-col items-center">
					<div class="grid place-content-center w-[19px] h-[19px] min-h-[19px] rounded-full bg-dj-blue/10">
						<div class="w-[9px] h-[9px] rounded-full bg-dj-blue"></div>
					</div>
					<div
						v-if="index != data.length - 1"
						class="my-[5px] min-h-[50px] h-full w-[1px] bg-dj-blue/10"
					></div>
				</div>
				<div class="flex flex-col ml-4 mb-4">
					<span class="text-dj-gray-dark text-sm mb-1">{{ item.date }}</span>
					<span class="font-medium">{{ item.story }}</span>
				</div>
			</li>
		</ul>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type TimelineData = {
	date: string;
	story: string;
};

export default defineComponent({
	name: "DjBoxTimeline",
	props: {
		data: {
			type: Array as PropType<TimelineData[]>,
			default: () => [],
		},
		title: {
			type: String,
		},
	},
});
</script>
